module.exports = __webpack_public_path__ + "static/media/pebom.c96ee5c4.jpg";